export default __webpack_public_path__ + "static/media/stands_ind_acuitybrands.a2309132.jpg";